import {
  Adapter,
  Channel,
  Currency,
  IAdapter,
  IChannel,
  ICurrency,
  IUserClientSubclientServicepoint,
  IUserClientSubclientServicepointData,
} from "@/entities";

export class UserClientSubclientServicepoint implements IUserClientSubclientServicepoint {
  readonly id?: number;
  readonly oidSol?: string;
  readonly codeSol?: string;
  readonly idSmartcash?: any;
  readonly uniqueCode?: any;
  readonly deviceId?: string;
  readonly type?: string;
  readonly description?: string;
  readonly address?: string;
  readonly openChannel?: boolean;
  readonly accountDate?: boolean;
  readonly active?: boolean;
  readonly adapters?: IAdapter[];
  readonly channels?: IChannel[];
  readonly currencies?: ICurrency[];
  readonly agilePickup: boolean;
  readonly econoCash: boolean;
  readonly flowApproval: boolean;

  constructor(data: IUserClientSubclientServicepointData) {
    this.id = data.id;
    this.oidSol = data.oidSol;
    this.codeSol = data.codeSol;
    this.idSmartcash = data.idSmartcash;
    this.type = data.type;
    this.uniqueCode = data.uniqueCode;
    this.deviceId = data.deviceId;
    this.description = data.description;
    this.address = data.address;
    this.openChannel = data.openChannel;
    this.accountDate = data.accountDate;
    this.active = data.active;
    this.agilePickup = data.agilePickup;
    this.econoCash = data.econoCash;
    this.flowApproval = data.flowApproval;

    this.adapters = data.adapters?.map((adapter) => new Adapter(adapter));
    this.channels = data.channels?.map((channel) => new Channel(channel));
    this.currencies = data.currencies?.map((currency) => new Currency(currency));
  }
}
